import {District} from '@/types'
import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {DISTRICT_URL} = apiEndPoints

interface DistrictService {
  getAllDistrict: () => Promise<AxiosResponse<District[]>>
}

const district: DistrictService = {
  async getAllDistrict(): Promise<AxiosResponse<District[]>> {
    const response = await apiClient.get(DISTRICT_URL)
    return response
  },
}

export {district}
